import React from 'react';
import './StepsList.css';

// Renders a math question's solution steps as an actual numbered list
// instead of one run-on sentence. `steps` is an array of plain-text step
// strings straight from the question generator's stored `steps` column.
export default function StepsList({ steps }) {
  if (!Array.isArray(steps) || steps.length === 0) return null;

  return (
    <ol className="steps-list">
      {steps.map((step, i) => (
        <li key={i}>{step}</li>
      ))}
    </ol>
  );
}
